export const ZONE_OPTIONS = [
    {
        id: 1,
        name: '1',
    },
    {
        id: 2,
        name: '2',
    },
    {
        id: 3,
        name: '3',
    },
]

export const SHIPMENT_TYPE_OPTIONS = [
    {
        id: 1,
        name: 'Авто',
    },
    {
        id: 2,
        name: 'Авиа',
    },
]

export const WARNING_MESSAGES = {
    invoiceNumber: 'Пожалуйста, выберите номер накладной',
    notDelivered: 'Накладная не доставлена',
}
